// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import AuthProvider from './context/AuthContext';
import AnalyticsProvider from './analytics/AnalyticsProvider';
import App from './App';
import AppErrorFallback from './components/AppErrorFallback';
import { initSentry } from './observability/initSentry';
import './styles/retailgo-tokens.css';
import './styles/retailgo-foundation.css';
import './styles/retailgo-shell.css';
import './styles/retailgo-screens.css';
import './styles/modal-shell.css';

initSentry();

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <Sentry.ErrorBoundary fallback={({ resetError }) => <AppErrorFallback resetError={resetError} />} showDialog={false}>
    <AuthProvider>
      <AnalyticsProvider>
        <App />
      </AnalyticsProvider>
    </AuthProvider>
  </Sentry.ErrorBoundary>
);
